//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentPlansDeliveryLocation', {
//        templateUrl: 'views/components/views/consignmentPlansDeliveryLocation/consignmentPlansDeliveryLocation.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'consignmentPlansDeliveryLocationService', 'rememberService', function (stateService, consignmentPlansDeliveryLocationService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListStockLocations: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadLocations() {
//                vm.model.itemsListStockLocations = await consignmentPlansDeliveryLocationService.listLocations();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region SAVE BACK FUNCTION

//            vm.saveLocation = function (item) {
//                Promise.all([
//                    rememberService.remember('consignmentplansdelivery.stocklocation_keyno', item.item_id),
//                    rememberService.remember('consignmentplansdelivery.stocklocation_name', item.item_name)
//                ]).then(() => {
//                    stateService.back();
//                    Promise.resolve();
//                });
//            }

//            // #endregion SAVE BACK FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadLocations();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
